module.exports = __webpack_public_path__ + "static/media/pause.a06516e2.svg";